import { CustomStorageProvider } from './../../providers/custom-storage/custom-storage';
import { Message } from '../../model/Message';
import { ChatInputImagePreviewPage } from './../../pages/chat-input-image-preview/chat-input-image-preview';
import { ModalController, AlertController, NavController } from 'ionic-angular';
import { Component, Output, EventEmitter, Input, OnInit, ViewChild, ElementRef, SimpleChanges, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Constants, FunctionType } from '../../util/Constants';
import { UserManagerProvider } from '../../providers/user-manager/user-manager';
import { Util } from '../../util/Util';
import { ChatConn } from '../../model/ChatConn';
import { AutoresizeDirective } from '../../directives/autoresize/autoresize';
import { WebSocketService } from '../../services/webSocketService';
import { FbTipsterInfo } from '../../model/FbTipsterInfo';
import { HorseRaceModel } from '../../model/horse/HorseRaceModel';

/**
 * Generated class for the ChatInputComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'chat-input',
  templateUrl: 'chat-input.html'
})

export class ChatInputComponent implements OnInit, OnChanges {
  uploadFileCallback: Function;
  @Input() message: Message;
  @Input() hideCamera?: boolean = false;
  @Input() hideSelfImg?: boolean = false;
  @Input() matchId: number;
  @Input() chatConn: ChatConn;
  @Input() tipsId?: number;
  @Input() isDisable?: boolean = false;
  @Input() isShare?: boolean  = false;
  @Input() functionType?: FunctionType = FunctionType.Horse;
  @Input() userId?: number;
  @Input() lang?: string;
  @Input() selectedTab: number;
  @Input() tipsterSelectedTab?:number;
  @Output() sendBtnClicked = new EventEmitter();
  @Output() inputHeightUpdated = new EventEmitter();
  @Output() replyBoxClosed = new EventEmitter();
  @Output() dismissImagePreview = new EventEmitter();
  @ViewChild("textInput") textInput: ElementRef;
  senderProfileImgSrc: string;
  @ViewChild(AutoresizeDirective) autoresize: AutoresizeDirective;
  tipsterInfo: FbTipsterInfo = new FbTipsterInfo(0, "", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, "", -1, false, false);

  constructor(private modalCtrl: ModalController, private alertCtrl: AlertController,
    private translateService: TranslateService, public customStorageService: CustomStorageProvider,
    private userManager: UserManagerProvider, private navCtrl: NavController,
    public webSocketService: WebSocketService) {
    //this.message = new Message(0, 0, 0, "", "", "", "", "");
    this.senderProfileImgSrc = Util.getImgUrl(Constants.Enum_ImageType.indexOf("Profile"),
        this.userManager.getLoginUserId())
  }

  public getTextInput() {
    return this.textInput.nativeElement;
  }

  ngOnChanges(changes: SimpleChanges) {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if ((this.functionType == FunctionType.Help || this.functionType == FunctionType.Football) && this.message != null) {
      this.message.senderTipScore = -1;
    }
  }

  ngOnInit() {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    var me = this;
    this.uploadFileCallback = function(base64Img) {
      var param = {};

      if (me.message == null) {
        me.message = new Message(0, 0, 0, "", "", -1, "", "", "", false, -1, Number.MIN_SAFE_INTEGER);
      }

      me.message.imgSrc = base64Img;
      param['message'] = me.message;
      param['parentChatInputComponent'] = me;
      param['matchId'] = me.matchId;
      param['functionType'] = me.functionType;
      let modalView = me.modalCtrl.create("ChatInputImagePreviewPage", param, {
        enableBackdropDismiss: false
      });
      modalView.present();
      modalView.onDidDismiss((chatInputImagePreview: ChatInputImagePreviewPage) => {
        if (chatInputImagePreview != null) {
          if (chatInputImagePreview.isCancel) {
            me.message.imgSrc = "";
          }
          if (chatInputImagePreview.isResizeContent) {
            console.log("chatInputImagePreview.isResizeContent");
            me.dismissImagePreview.emit(me);
          }
        }
      })
    }
    this.webSocketService.getTipsterInfoObj(this.tipsterInfo, this.userManager.getLoginUserId());
  }

  sendBtnOnClick() {
    if (this.isDisable) {
      return;
    }
    let sTitle = "";
    let sSubTitle = "";
    let role = this.customStorageService.get<string>(Constants.STORAGE_KEY_ROLE);
    if (role == Constants.ROLE_GUEST) {
      sTitle = this.translateService.instant("kindReminder");
      sSubTitle = this.translateService.instant("guestModeLimitedFeatureChatInput");
      if (this.functionType == FunctionType.Help) {
        sSubTitle = this.translateService.instant("guestModeLimitedFeatureChatInputHelp");
      }
    } else if (this.message.content == "") {
      sTitle = this.translateService.instant("error");
      sSubTitle = this.translateService.instant("alertMessageEmptyMessage");
    } else if (this.message.content.length > 500) {
      sTitle = this.translateService.instant("error");
      sSubTitle = this.translateService.instant("alertMessageForumMaxCharacters");
    }
    if (sSubTitle != "") {
      let alert = this.alertCtrl.create({
        title: sTitle,
        subTitle: sSubTitle,
        buttons: [this.translateService.instant("ok")]
      })
      alert.present();
      return;
    }

    if (this.isShare) {
      this.chatConn.addShareComment(this.message.content, this.tipsId, this.userId, this.lang).then(
        result => {
          console.log("Promise ok");
          let subtitle = "";
          console.log("Function Type" + this.functionType);
          if (this.functionType == FunctionType.Horse) {
            if (result.returnInfo == 0) {
              subtitle = this.translateService.instant("shareToKintipsHorsePackageForum");
            } else {
              console.log("Race ID" + result.returnInfo);
              let raceCards = this.customStorageService.get<Array<HorseRaceModel>>(Constants.STORAGE_KEY_RACE_CARDS);
              let raceNum =  Util.getRaceNum(raceCards, result.returnInfo);
              console.log("Race Num" + raceNum);
              subtitle = this.translateService.instant("shareToKintipsHorseInRaceForum", { raceNum: raceNum});
            }
          } else if (this.functionType == FunctionType.Football) {
            subtitle = this.translateService.instant("shareToKintipsFbForum", { raceNum: Constants.HORSE_MAX_STRONG_CONFIDENCE_COUNT });
          }
          if (subtitle != null && subtitle != "") {
            let alert = this.alertCtrl.create({
              title: this.translateService.instant("success"),
              subTitle: subtitle,
              buttons: [this.translateService.instant("ok")]
            })
            alert.present();
          }
          this.autoresize.adjustHeight();
          this.message.resetAfterSendMsg();
          this.sendBtnClicked.emit(this);
        },
        err => {
          console.log("Promise error chatInputComponent");
          console.log("err");
          this.sendBtnClicked.emit(this);
        }
      );
    } else {
      console.log("sendBtnOnClick this.matchId: " + this.matchId);
      var iRefCmtId: number = (this.message.replyMessage == null) ? 0 : this.message.replyMessage.id;

      var img = "";
      if (this.message.imgSrc != null) {
        // extract the data part
        img = this.message.imgSrc.split(",")[1];
      }
      this.chatConn.addComment(this.matchId, this.message.content, img, iRefCmtId, this.tipsId).then(
        result => {
          console.log("Promise ok");
          //console.log(JSON.stringify(result));
          //this.getFbCommentWs(sRaceId);
          this.autoresize.adjustHeight();
          this.message.resetAfterSendMsg();

          // this.getTextInput().focus();
          // console.log("this.getTextInput().focus()");
          this.sendBtnClicked.emit(this);
        },
        err => {
          console.log("Promise error chatInputComponent");
          console.log("err");
          this.sendBtnClicked.emit(this);
        }
      );
    }
    //this.sendBtnCallback(this);
  }

  clickSendBtn(chatInputComponent: ChatInputComponent) {
    this.sendBtnClicked.emit(chatInputComponent);
  }

  textAreaUpdatedHeight() {
    this.inputHeightUpdated.emit(this);
  }

  closeReplyBoxBtnOnClick() {
    this.replyBoxClosed.emit(this);
  }

  showTipsterInfo() {
    // if (this.functionType == FunctionType.Help || this.functionType == FunctionType.Football) {
    //   this.navCtrl.push("TipsterInfoPage", {"tipsterId": this.userManager.getLoginUserId()});
    // } else {
    //   this.navCtrl.push("HorseTipsterInfoPage", {"tipsterId": this.userManager.getLoginUserId(), "selectedTab": this.matchId == 0 ? 1 : 0});
    // }

    if (this.tipsterSelectedTab!=null) {
      this.navCtrl.push("TipsterInfoPage", {"tipsterId": this.userManager.getLoginUserId(),"selectedTab":this.selectedTab, "tipsterSelectedTab": this.tipsterSelectedTab});
    } else {
      this.navCtrl.push("TipsterInfoPage", {"tipsterId": this.userManager.getLoginUserId(),"selectedTab":this.selectedTab, "tipsterSelectedTab": 0});
    }
  }

  getLoginUserId() {
    return this.userManager.getLoginUserId();
  }
}



// WEBPACK FOOTER //
// ./src/components/chat-input/chat-input.ts